import {Component, EventEmitter, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Formio } from '@formio/angular';
import { EnvConfig } from 'src/environments/environment';
import { Submission } from '../../model/submission.model';
import { SegnalazioniRepository } from '../../model/segnalazioni.repository';
import {tap} from "rxjs/operators";
import {english} from "../../../assets/i18n/en-GB";
import {italian} from "../../../assets/i18n/it-IT";
import {LanguageService} from "../../services/language.service";

@Component({
  templateUrl: './end.component.html',
  styleUrls: ['./end.component.css']
})
export class EndComponent  implements OnInit {
  private jwtToken:string = "";
  i18n: any;
  language = new EventEmitter();
  form: any;

  constructor(
    private route:Router,
    private sub: Submission,
    private repository: SegnalazioniRepository,
    private languageService: LanguageService)
  {
  }

  async ngOnInit(): Promise<void> {
    this.languageService.selectedLang$.pipe(
      tap(async (data) => {
        if (data?.code.slice(0, 2) === 'en') {
          this.i18n = english;
          this.i18n.language = 'en';
          this.language.emit('en');
          await this.loadSubmittedForm();
        } else {
          this.i18n = italian;
          this.i18n.language = 'it';
          this.language.emit('it');
          await this.loadSubmittedForm();
        }
      })
    ).subscribe();
  }

  async loadSubmittedForm() {
    if (this.sub.getId())
    {
      // rimuovo il salvataggio dalla local storage
      localStorage.clear();

      this.jwtToken = (await this.repository.authenticate()).token;

      // Inserire la logica di sottomissione asincrona
      if (this.sub.getSync())
      {
        this.sub.setProt((await this.repository.getResponseWaitProtocollo(this.sub.getId(),this.jwtToken)).numeroProtocollo);
        if (!this.sub.getProt())
          this.sub.setProt(this.i18n.language === 'en' ? 'TO BE ASSIGNED' : 'DA ASSEGNARE');
        //await this.repository.postResponseWaitSottomissione(this.sub.getId(),this.sub.getProt(),this.jwtToken);
      }
      else
        this.sub.setProt(this.i18n.language === 'en' ? 'TO BE ASSIGNED' : 'DA ASSEGNARE');

      const formio = new Formio(EnvConfig.appUrl+'/'+EnvConfig.formId+'/submission/'+this.sub.getId());
      formio.loadForm().then((form: any) => {
        form.display = 'form';
        Formio.createForm(document.getElementById('formio-full'), form, {
          buttonSettings: {
            showCancel: false,
            showSubmit: false
          },
          language: this.i18n.language,
          i18n: {
            it: italian,
            en: english
          },
          noDefaultSubmitButton: true,
          readOnly: true,
          flatten: true,
        }).then(function(instance) {
          formio.loadSubmission().then(function(submission: any) {

            instance.submission = submission;

            instance.getComponent('submit').component.hidden = true;
            instance.getComponent('introduzione').component.hidden = true;
            if (submission.valueSPID === 'true') {
              instance.getComponent('codiceFiscale_soggetto_segnalante').component.hidden = true;
              instance.getComponent('soggettoSegnalantePanelPanel').component.hidden = true;
            }
            instance.getComponent('sintesi_cig').component.hidden = true;
            instance.getComponent('bottoni_ricerca_cig').component.hidden = true;
            instance.getComponent('valida_cig').component.hidden = true;

          });
        })
      });
    } else {
      this.route.navigate(['/form']);
    }
  }

  get submission(): string {
    return this.sub.getId();
  }

  prot(): string {
    return this.sub.getProt();
  }

  msgProt(): string {
    if (this.prot())
      return "Protocollo: "+this.prot();
    else
      return "ID sottomissione: "+this.sub.getId();
  }

  public async downloadAsPDF()
  {
    const data = await this.repository.downloadReportPdf(this.sub.getId());
    const blob = new Blob([data], { type: 'application/pdf' });
    const filename = "ricevuta_" + this.sub.getId() + ".pdf";
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    // console.log("ID: "+this.sub.getId)
    //   FileSaver.saveAs(EnvConfig.backendUrl+
    //                     '/ws-report/report?id='+this.sub.getId(),
    //                     "ricevuta_"+this.sub.getId()+".pdf");
  }

  /*public downloadAsPDF()
  {
    var data = document.getElementById('content');
    html2canvas(data as HTMLElement).then(canvas => {
        var imgWidth = 208;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        var doc = new jsPDF('p', 'mm');
        var position = 0;
        const contentDataURL = canvas.toDataURL('image/png')

        doc.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save( 'submission.pdf');
    });
  }*/

  public edit()
  {
    var formio = new Formio(EnvConfig.appUrl+'/'+EnvConfig.formId+'/submission/'+this.sub.getId());
    formio.loadForm().then(function(form: any) {
      form.display = 'form';
      Formio.createForm(document.getElementById('formio-full'), form, {
        renderMode: 'flat',
        readOnly: false
      }).then(function(instance) {
        formio.loadSubmission().then(function(submission: any) {
          instance.submission = submission;
        });
      });
    });
  }
}
